import { render, staticRenderFns } from "./PreciosRegionesAnexasComponent.vue?vue&type=template&id=713eb462"
import script from "./PreciosRegionesAnexasComponent.vue?vue&type=script&lang=js"
export * from "./PreciosRegionesAnexasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports